<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex md12 v-if="!cargandoDatos">
                <v-card>
                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0">Selección de especialidad</h3>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-select
                                :items="especialidades"
                                v-model="especialidadSeleccionada"
                                item-value="id"
                                item-text="especialidad"
                        ></v-select>
                    </v-card-text>
                    <v-divider class="mt-5"></v-divider>
                    <v-card-actions class="pa-3">
                        <v-btn color="teal" class="white--text" large @click="guardarEspecialidad">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="cargandoDatos" max-width="250px" persistent>
            <v-card>
                <v-card-title>
                    <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
                    <v-spacer></v-spacer>
                    <span style="max-width: 135px">Cargando Especialidades Disponibles</span>
                </v-card-title>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'EspecialidadPage',
    data: () => ({
      cargandoDatos: false,
      especialidades: [],
      especialidadSeleccionada: ''
    }),
    created () {
      this.getEspecialidades()
    },
    methods: {
      getEspecialidades () {
        this.cargandoDatos = true
        axios.get('alumno/seleccion-especialidad')
          .then(request => {
            this.cargandoDatos = false
            console.log(request.data)
            this.especialidades = request.data
          })
          .catch(() => {
            console.log('Error')
          })
      },
      guardarEspecialidad () {
        console.log('Guardando')
        axios.put('alumno/seleccion-especialidad', { especialidad: this.especialidadSeleccionada })
          .then(() => {
            console.log('Guardada')
            this.$router.push('/inscripciones/reinscripcion')
          })
          .catch(() => {
            console.log('No se pudo guardar')
          })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/inscripciones/EspecialidadPage.vue